import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { FieldWrap } from "@/components/Field";
import { api, errMsg } from "@/lib/api";

const inputCls = "h-11 bg-white text-slate-900";

export function YearFiguresDialog({ open, onClose, periodKey, label, cfg, yearData, onSaved }) {
  const [bf, setBf] = useState("0");
  const [manual, setManual] = useState({});
  useEffect(() => { if (open) { setBf(String(yearData?.balance_forward ?? 0)); setManual({ ...(yearData?.manual || {}) }); } }, [open, yearData]);
  const lines = (cfg?.income_lines || []).filter((l) => l.source === "manual");

  const save = async (e) => {
    e.preventDefault();
    try {
      await api.put(`/finance/period/${periodKey}`, { balance_forward: Number(bf || 0), manual: Object.fromEntries(Object.entries(manual).map(([k, v]) => [k, Number(v || 0)])) });
      toast.success("Report figures saved");
      onSaved();
      onClose();
    } catch (err) { toast.error(errMsg(err)); }
  };

  return (
    <Dialog open={open} onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="max-h-[92vh] max-w-md overflow-y-auto" data-testid="year-figures-dialog">
        <DialogHeader>
          <DialogTitle>Report figures</DialogTitle>
          <DialogDescription>{label}. Amounts typed in for this period; other income and all expenses total automatically.</DialogDescription>
        </DialogHeader>
        <form onSubmit={save} className="space-y-4">
          <FieldWrap label="Balance Forward ($)"><Input type="number" step="0.01" value={bf} onChange={(e) => setBf(e.target.value)} className={inputCls} data-testid="year-balance-forward" /></FieldWrap>
          {lines.map((l) => (
            <FieldWrap key={l.id} label={`${l.label} ($)`}>
              <Input type="number" step="0.01" value={manual[l.id] ?? ""} onChange={(e) => setManual({ ...manual, [l.id]: e.target.value })} className={inputCls} data-testid={`year-manual-${l.id}`} />
            </FieldWrap>
          ))}
          <Button type="submit" className="w-full" data-testid="year-figures-save">Save</Button>
        </form>
      </DialogContent>
    </Dialog>
  );
}
